import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCHa0VfYLLuiBdx27dE67zGYGuHdrj4CYA",
  authDomain: "desafiospicantes-57e8b.firebaseapp.com",
  projectId: "desafiospicantes-57e8b",
  storageBucket: "desafiospicantes-57e8b.firebasestorage.app",
  messagingSenderId: "372351398157",
  appId: "1:372351398157:web:74d121f787fa3f2d1fc044",
  measurementId: "G-8CXD3VEJEJ",
};

const app = initializeApp(firebaseConfig);

export default app;
